import React, { useState, useEffect } from "react";
import axios from "axios";
import { getMenus, saveRoomsOrders } from "../../Pages/apis";
import { Spinner } from "react-bootstrap";
import "./../../Assets/css/utility.css";
import "../../Assets/css/hide_Inc_Dec.css";

export const NewOrder = ({ roomObj, setOrderModal, setCheckOrder }) => {
  const [allMenus, setAllMenus] = useState([]);
  const [isLoading, setIsloading] = useState(0);
  const [menuResponse, setMenuResponse] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [selectedMenus, setSelectedMenus] = useState([]);
  const [formData, setFormData] = useState();
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: "Bearer " + user?.token,
  };

  useEffect(() => {
    axios
      .get(getMenus)
      .then((res) => {
        // if (res.data.status === 200) {
        let group = [];
        let customizeMenu = res.data.menus;
        for (let i = 0; i < customizeMenu.length; i++) {
          for (let j = 0; j < customizeMenu[i]?.menu_items.length; j++) {
            customizeMenu[i].menu_items[j] = {
              ...customizeMenu[i].menu_items[j],
              check: false,
              qty: "",
            };
          }
        }

        setAllMenus(customizeMenu);
        setMenuResponse(true);
        // }
      })
      .catch((err) => {
        setMenuResponse(false);
        setFetchError(err);
      });
  }, []);

  useEffect(() => {}, [allMenus]);
  const handleCheckBox = (e, outer, inner) => {
    const isChecked = e.target.checked;
    let id = e.target.value;

    let deepCopy = JSON.parse(JSON.stringify(allMenus));
    if (isChecked) {
      deepCopy[outer].menu_items[inner].qty = 1;
      deepCopy[outer].menu_items[inner].check = true;
    } else {
      deepCopy[outer].menu_items[inner].qty = "";
      deepCopy[outer].menu_items[inner].check = false;
    }
    setAllMenus(deepCopy);
  };
  const handleQuantity = (e, outer, inner) => {
    const id = e.target.id;
    const value = e.target.value;

    let deepCopy = JSON.parse(JSON.stringify(allMenus));
    if (value >= 1) {
      deepCopy[outer].menu_items[inner].qty = value;
      deepCopy[outer].menu_items[inner].check = true;
    } else if (value == 0) {
      deepCopy[outer].menu_items[inner].qty = value;
      deepCopy[outer].menu_items[inner].check = false;
    } else if (value == "" && value < 0) {
      deepCopy[outer].menu_items[inner].qty = "";
      deepCopy[outer].menu_items[inner].check = false;
    }
    setAllMenus(deepCopy);
  };

  const handleButtons = (qty, outer, inner) => {
    let deepCopy = JSON.parse(JSON.stringify(allMenus));
    if (qty === -1) {
      deepCopy[outer].menu_items[inner].qty = --deepCopy[outer].menu_items[
        inner
      ].qty;

      if (deepCopy[outer].menu_items[inner].qty < 0) {
        deepCopy[outer].menu_items[inner].qty = 0;
      } else if (deepCopy[outer].menu_items[inner].qty == 0) {
        deepCopy[outer].menu_items[inner].check = false;
      } else {
        deepCopy[outer].menu_items[inner].check = true;
      }
    } else {
      deepCopy[outer].menu_items[inner].qty = ++deepCopy[outer].menu_items[
        inner
      ].qty;
      deepCopy[outer].menu_items[inner].check = true;
    }

    setAllMenus(deepCopy);
  };

  const handleSubmit = () => {
    let selected_items = [];
    allMenus.map((item) => {
      item.menu_items.map((ele) => {
        if (ele?.check == true && ele?.qty >= 1) {
          selected_items = [...selected_items, { id: ele?.id, qty: ele?.qty }];
        }
      });
    });
    if (selected_items.length < 1) {
      alert("Please Select Item");
      return false;
    }
    setLoading(true);
    let payload = {
      room_code: roomObj?.code,
      orders: selected_items,
    };

    axios
      .post(saveRoomsOrders, { payload }, { headers: headers })
      .then((res) => {
        console.log();
        if (res?.data?.status === 200) {
          setOrderModal(false);
          setCheckOrder(true);
        }
      });

    setLoading(false);
  };
  const handleModal = () => {
    setOrderModal(false);
  };

  return (
    <div className="flex-column">
      <label className="text-bold">Room Name:</label>
      <input
        className="form-control mb-2"
        value={roomObj?.name}
        type="text"
        disabled
      />
      <label className="text-bold">Menu:</label>
      <br />
      {allMenus &&
        allMenus.map((item, outer) => {
          return (
            <div className="ml-5 mr-5" key={outer}>
              <label className="text-bold" key={item.id}>
                {item?.name}:
              </label>
              <br />
              {item?.menu_items.map((ele, inner) => (
                <div
                  className="d-flex justify-content-between align-items-center mb-3 mr-5"
                  key={ele?.id}
                >
                  <div className="d-flex">
                    <input
                      type="checkbox"
                      checked={ele?.check ? true : false}
                      value={ele?.id}
                      onChange={(e) => handleCheckBox(e, outer, inner)}
                    />
                    <p>{ele?.name}</p>
                  </div>
                  <div className="custom_flex">
                    <button
                      onClick={() => handleButtons(-1, outer, inner)}
                      className="border-btn"
                    >
                      −
                    </button>
                    <input
                      type="number"
                      id={ele?.id}
                      value={ele?.qty}
                      onChange={(e) => handleQuantity(e, outer, inner)}
                      className="input_design"
                    />
                    <button
                      onClick={() => handleButtons(1, outer, inner)}
                      className="border-btn"
                    >
                      +
                    </button>
                  </div>
                </div>
              ))}
            </div>
          );
        })}
      <div className="m-3">
        {!menuResponse && isLoading === 0 && allMenus.length === 0 && (
          <Spinner animation="border" role="status">
            <span className="visually-hidden"></span>
          </Spinner>
        )}
        {menuResponse && allMenus.length === 0 && (
          <p className="error_text">No Menus Found</p>
        )}

        {!menuResponse && isLoading === 1 && allMenus.length === 0 && (
          <p className="error_text">{fetchError}</p>
        )}
      </div>

      <div className="custom_flex justify-content-end ">
        <button
          onClick={handleSubmit}
          className="btn btn-primary btn-sm active mt-3 mr-1"
          role="button"
        >
          {loading ? (
            <div className="custom_spinner text-light" role="status"></div>
          ) : (
            ""
          )}
          Submit
        </button>
        <button
          onClick={handleModal}
          className="btn btn-secondary btn-sm active mt-3 "
          role="button"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};
